// @flow
import { default as TreeTemplate } from './templates/tree.html';
import { Tree } from 'rgs-nfd-ui-kit/ko-components/tree/tree';

export const COMPONENTS_TREE_NAME = 'tree';
export const COMPONENTS_TREE_ENTITIES = [
	{
		name: COMPONENTS_TREE_NAME,
		entity: Tree,
		template: TreeTemplate,
	},
];

